// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});


	const dropdown = new bootstrap.Dropdown('[data-bs-toggle="dropdown"]')
	const myCollapsible = document.getElementById('navbarHeader')
	const headerNAv = document.getElementById('headerNav')

	myCollapsible.addEventListener('hide.bs.collapse', event => {
		headerNAv.classList.remove('showed')
	})

	myCollapsible.addEventListener('show.bs.collapse', event => {
		headerNAv.classList.add('showed')
	})

	document.querySelector('.navbar-nav > li:last-of-type a').classList.remove('nav-link');
	document.querySelector('.navbar-nav > li:last-of-type a').classList.add('btn');
	document.querySelector('.navbar-nav > li:last-of-type a').classList.add('btn-primary');

	document.querySelector('.navbar-nav > li.menu-item-788 a').classList.remove('nav-link');
	document.querySelector('.navbar-nav > li.menu-item-788 a').classList.add('btn');
	document.querySelector('.navbar-nav > li.menu-item-788 a').classList.add('btn-danger');

})();
